export const EP_CODES_EC_02_03_05 = [
    { value: 'EP 01', label: 'EP 01' },
    { value: 'EP 02', label: 'EP 02' },
    { value: 'EP 03', label: 'EP 03' },
    { value: 'EP 04', label: 'EP 04' },
    { value: 'EP 05', label: 'EP 05' },
    { value: 'EP 06', label: 'EP 06' },
    { value: 'EP 07', label: 'EP 07' },
    { value: 'EP 08', label: 'EP 08' },
    { value: 'EP 09', label: 'EP 09' },
    { value: 'EP 10', label: 'EP 10' },
    { value: 'EP 11', label: 'EP 11' },
    { value: 'EP 12', label: 'EP 12' },
    { value: 'EP 13', label: 'EP 13' },
    { value: 'EP 14', label: 'EP 14' },
    { value: 'EP 15', label: 'EP 15' },
    { value: 'EP 16', label: 'EP 16' },
    { value: 'EP 17', label: 'EP 17' },
    { value: 'EP 18', label: 'EP 18' },
    { value: 'EP 19', label: 'EP 19' },
    { value: 'EP 20', label: 'EP 20' },
    { value: 'EP 25', label: 'EP 25' },
    { value: 'EP 27', label: 'EP 27' },
    { value: 'EP 28', label: 'EP 28' }
];
export const EP_CODES_EC_02_05_07 = [
    { value: 'EP 03', label: 'EP 03' },
    { value: 'EP 04', label: 'EP 04' },
    { value: 'EP 05', label: 'EP 05' },
    { value: 'EP 06', label: 'EP 06' },
    { value: 'EP 07', label: 'EP 07' },
    { value: 'EP 08', label: 'EP 08' },
    { value: 'EP 09', label: 'EP 09' },
    { value: 'EP 10', label: 'EP 10' }
];
export const EC_TYPE_02_03_05 = '1';
export const EC_TYPE_02_05_07 = '2';
export const EC_TYPES = {
    [EC_TYPE_02_03_05]: 'EC 02.03.05',
    [EC_TYPE_02_05_07]: 'EC 02.05.07'
};
